import { render, staticRenderFns } from "./shareDashboard.vue?vue&type=template&id=20c5593c&scoped=true"
import script from "./shareDashboard.vue?vue&type=script&lang=js"
export * from "./shareDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c5593c",
  null
  
)

export default component.exports